import {useContext, useEffect, useState} from "react"
import BoxSelectable from "src/components/misc/BoxSelectable";
import {ClientUserDTO, ClientUserDTOFields} from "src/types/client/clientData";
import {CompanyContext, CompanyContextValue} from "../../../../../pages/solicitation-new/context/companyContext";
import {numberFormatter} from "../../../../../utils/formatters/numberFormatter";
import {Typography} from "@mui/material";
import Box from "@mui/material/Box";

interface EmpresaSelectProps {
    companies?: ClientUserDTO[]
}
const EmpresaSelect = ({companies}: EmpresaSelectProps) => {
    const { loaded, clientId, setClientId } = useContext<CompanyContextValue>(CompanyContext);
    
    //const [openCompanySelector, setOpenCompanySelector] = useState<boolean>(false);
    
    const [value, setValue] = useState<ClientUserDTO | undefined>();
    
    //const showCompanySelector = () => setOpenCompanySelector(true);
    
    //const closeCompanySelector = () => setOpenCompanySelector(false);

    useEffect(() => {
        if (companies && companies.length !== 0) {
            setValue(companies?.[0])
            if (!clientId || clientId == 0) setClientId(companies?.[0][ClientUserDTOFields.ClientId])
        }
    }, [companies]);

    return (
        <>
            {
                value ?
                <BoxSelectable title={value[ClientUserDTOFields.BusinessName]}
                               subtitle={numberFormatter.toCuitString(value[ClientUserDTOFields.CUIT])}
                               size={'small'}
                               icon={"carbon:location-company"}
                               
                               //onClick={showCompanySelector}
                    
                               isSelected={loaded}
                />
                    :
                    !companies || companies.length == 0 &&
                        <Box sx={{ border: '1px solid black', borderRadius: '6px', padding: '8px'}}>
                            <Typography fontSize={16} fontWeight={600} textAlign={'center'}>
                                No se encontró empresa cargada
                            </Typography>
                            <Typography fontSize={13} textAlign={'center'}>
                                Presione en "Añadir Empresa" para continuar operando
                            </Typography>
                        </Box>
            }
                    
            {
                        
                /*
                        companies?.length == 0 ?
                        
                        /*
                        <BoxSelectable title={'Seleccione empresa'} isSelected={loaded} onClick={showCompanySelector}
                                       subtitle={'Haga click aquí para seleccionar sus empresas cargadas'}
                        />
                        :
                        <>
                            <Typography fontSize={15} fontWeight={500}>No hay empresas cargadas.</Typography>
                            <Typography fontSize={15} fontWeight={500}>Presione en Añadir Empresa para continuar operando</Typography>
                        </>
                        
                        */}
            
            {
                
                /*
                
                <CompanySelectDialog open={openCompanySelector}
                                     onClose={closeCompanySelector}
                />
                
                 */
                
            }
        </>
    )
}

export default EmpresaSelect